/**
 * Uyarı sesi tercihi. Cihaza ait (sunucuya gitmez): aynı restoranda kasa sesli,
 * ofisteki tablet sessiz olabilsin. Depolama kapalıysa (gizli pencere) ses açık
 * kabul edilir — uyarının kaçması sesin rahatsız etmesinden kötü.
 */
const KEY = 'orderceo.alertsMuted';

export function muted() {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
}

export function setMuted(v) {
  try { localStorage.setItem(KEY, v ? '1' : '0'); } catch { /* yok sayılır */ }
}
